import { createSlice } from '@reduxjs/toolkit';
import { resetAllSlices } from '../../Providers/mainStore.slice';

const initialState = {
  dialogOpen: false,
  docsToSign: [],
  videoAgreementId: null,
};

const documentSignatureSlice = createSlice({
  name: 'documentSignature',
  initialState,
  reducers: {
    setDocumentSignatureState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetDocumentSignatureState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllSlices, () => {
      return initialState;
    });
  },
});

export const { setDocumentSignatureState, resetDocumentSignatureState } =
  documentSignatureSlice.actions;

export default documentSignatureSlice.reducer;
